<div class="toast-stack" aria-live="polite">
  @for (toast of toastService.toasts(); track toast.id) {
    <div class="toast" [class.toast-error]="toast.type === 'error'" role="status">
      <mat-icon>{{ toast.type === 'error' ? 'error_outline' : 'check_circle' }}</mat-icon>
      <p>{{ toast.message }}</p>
      <button type="button" aria-label="Dismiss" (click)="toastService.dismiss(toast.id)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }
</div>
